import React, { FC } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import "./App.css";
import { CoherentRoute } from "./CoherentRoute";
import { Layout } from "./components/layouts/Layout";
import { LayoutWithPanel } from "./components/layouts/LayoutWithPanel";
import { Cosa } from "./components/steps/Cosa";
import { Sconto } from "./components/steps/Sconto";
import { stepPath } from "./config/stepPath";
import { Step } from "./types/Step";

const App: FC = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route exact path="/">
          <Redirect to={stepPath[Step.COSA]} />
        </Route>
        <Route path={stepPath[Step.COSA]}>
          <Layout>
            <Cosa />
          </Layout>
        </Route>
        <CoherentRoute path={stepPath[Step.SCONTO]} step={Step.SCONTO}>
          <LayoutWithPanel>
            <Sconto />
          </LayoutWithPanel>
        </CoherentRoute>
        <Route path="/:intermediario">
          <Switch>
            <Route exact path="/:intermediario/">
              <Redirect to={"." + stepPath[Step.COSA]} />
            </Route>
            <Route path={"/:intermediario" + stepPath[Step.COSA]}>
              <Layout>
                <Cosa />
              </Layout>
            </Route>
            <CoherentRoute path={"/:intermediario" + stepPath[Step.SCONTO]} step={Step.SCONTO}>
              <LayoutWithPanel>
                <Sconto />
              </LayoutWithPanel>
            </CoherentRoute>
          </Switch>
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
